<template>
<div>
    <!-- Filtros de busqueda con boton -->
    <div class="ibox sombra-light" v-if="!Mostrarlista">
        <div class="ibox-title">
            <h5>
                <i class="fal fa-chart-bar"></i> Reporte Interacciones Sin Watson
            </h5>
        </div>
        <div class="ibox-content">
            <form @submit.prevent="getreporte">
                <b-overlay :show="buttonDisable" rounded="sm">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Fecha de inicio</label>
                                    <div class="input-group">
                                        <b-form-datepicker id="fechaInicioGrafico" v-model="form.fechaInicio" placeholder="Fecha de inicio" v-bind="datepicker.etiquetas[datepicker.idioma] || {}" :locale="datepicker.idioma" class="mb-2"></b-form-datepicker>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Fecha de término</label>
                                    <div class="input-group">
                                        <b-form-datepicker id="fechaTerminoGrafico" v-model="form.fechaTermino" placeholder="Fecha de término" v-bind="datepicker.etiquetas[datepicker.idioma] || {}" :locale="datepicker.idioma" class="mb-2"></b-form-datepicker>
                                    </div>
                                </div>
                            </div>
                            <div class="offset-md-6 col-md-6">
                                <b-button block variant="primary" type="submit" @submit="getreporte" :disabled="buttonDisable" :class="`buscar-info-dashboard`">Buscar</b-button>
                            </div>
                        </div>
                    </div>
                </b-overlay>
            </form>
            <transition name="fade">
                <div class="container" v-if="mostrarGraficos">
                    <div class="row">
                        <div class="col-lg-3">
                            <button type="button" class="btn p-0 btn-block" @click="mostrarReporte('Interacciones')">
                                <div class="widget navy-bg">
                                    <div class="row">
                                        <div class="col-3">
                                            <i class="far fa-abacus fa-4x"></i>
                                        </div>
                                        <div class="col-9 text-right">
                                            <span> Total Interacciones </span>
                                            <h2 class="font-bold">{{ total_chatbot + total_whatsapp + total_facebook }}</h2>
                                        </div>
                                    </div>
                                </div>
                            </button>
                        </div>
                        <div class="col-lg-3">
                            <button type="button" class="btn p-0 btn-block" @click="mostrarReporte('Whatsapp')">
                                <div class="widget navy-bg">
                                    <div class="row">
                                        <div class="col-3">
                                            <i class="fab fa-whatsapp-square fa-4x"></i>
                                        </div>
                                        <div class="col-9 text-right">
                                            <span> Total Whatsapp </span>
                                            <h2 class="font-bold">{{ total_whatsapp }}</h2>
                                        </div>
                                    </div>
                                </div>
                            </button>
                        </div>
                        <div class="col-lg-3">
                            <button type="button" class="btn p-0 btn-block" @click="mostrarReporte('Facebook')">
                                <div class="widget navy-bg">
                                    <div class="row">
                                        <div class="col-3">
                                            <i class="fab fa-facebook-square fa-4x"></i>
                                        </div>
                                        <div class="col-9 text-right">
                                            <span> Total Facebook </span>
                                            <h2 class="font-bold">{{ total_facebook }}</h2>
                                        </div>
                                    </div>
                                </div>
                            </button>
                        </div>
                        <div class="col-lg-3">
                            <button type="button" class="btn p-0 btn-block" @click="mostrarReporte('Chatbot')">
                                <div class="widget navy-bg">
                                    <div class="row">
                                        <div class="col-3">
                                            <i class="fas fa-user-robot fa-4x"></i>
                                        </div>
                                        <div class="col-9 text-right">
                                            <span> Total Chatbot </span>
                                            <h2 class="font-bold">{{ total_chatbot }}</h2>
                                        </div>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="row" v-if="!buttonDisable">
                        <div class="col-lg-12">
                            <div class="ibox-title">
                                <h5>Opciones Presionadas Whatsapp y Facebook</h5>
                            </div>
                            <data-table :id="dt.id" :datos="dt2.datos" :columnas="dt2.columnas" :responsive="true" :font-size="12">

                            </data-table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="ibox float-e-margins">
                                <div class="ibox-title">
                                    <h5>Total Interacciones</h5>
                                </div>
                                <div class="ibox-content">
                                    <div>
                                        <div id="pie2"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="ibox float-e-margins">
                                <div class="ibox-title">
                                    <h5>Total Estados Derivaciones</h5>
                                </div>
                                <div class="ibox-content">
                                    <div>
                                        <div id="pie"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

    </div>
    <div class="ibox sombra-light" v-if="Mostrarlista">
        <div class="ibox-title">
            <h5>
                <i class="fal fa-chart-bar"></i> Reporte {{tipo_reporte}}
            </h5>
            <div class="ibox-tools">
                <div class="btn-group">
                    <button class="btn btn-primary" @click="graficar">Volver</button>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div class="graficos">
                <div class="ibox sombra-light">
                    <div class="ibox-content">
                        <b-row>
                            <b-col cols="12">
                                <data-table :id="dt.id" :datos="dt.datos" :columnas="dt.columnas" :responsive="true" :font-size="12">
                                    <template v-slot:detalles="item">
                                        <div>
                                            <button class="btn btn-primary" @click="abrirModal(item)">Ver Conversacion</button>
                                        </div>
                                    </template>
                                </data-table>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </transition>
        <div class="modal fade" role="dialog" id="Modal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Conversacion </h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12" style="display: flex;">
                                <div class="ibox" style="overflow: scroll; width: 418px; justify-content: center;">
                                    <div v-for="(item, index) in detalles" :key="index">
                                        <div :class="'conver '+ revisa_direccion(item) "> {{muestra_mensaje(item)}}
                                            <div style="font-size: 11px;">
                                                {{item.created_at}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
var moment = require('moment');
import { labels, locale } from "../../datepicker-intl.json";
import DataTable from '../../DataTableLuis.vue';
export default {
    components: { DataTable },
    data() {
        return {
            form: {
                fechaInicio: moment().subtract(1, "day").format("YYYY-MM-DD"),
                fechaTermino: moment().format("YYYY-MM-DD"),
            },
            datepicker: {
                etiquetas: labels,
                idioma: locale,
            },
            buttonDisable: false,
            parametrosValidos: false,
            mostrarGraficos: false,
            total_whatsapp: 0,
            total_facebook: 0,
            total_chatbot: 0,
            Mostrarlista: false,
            tipo_reporte: "",
            datos: [],
            dt: {
                id: 'dt',
                columnas: [
                    { nombre: 'Direccion', nombre_variable: 'direccion_mensaje' },
                    { nombre: 'Emisor', nombre_variable: 'emisor' },
                    { nombre: 'Receptor', nombre_variable: 'receptor' },
                    { nombre: 'Canal', nombre_variable: 'canal' },
                    { nombre: 'InterGlobal', nombre_variable: 'id_inter_global' },
                    { nombre: 'Fecha', nombre_variable: 'created_at' },
                    { nombre: 'Conversacion', nombre_variable: 'detalles', slot: 1 },
                ],
                datos: []
            },
            dt2: {
                id: 'dt2',
                columnas: [
                    { nombre: 'Boton', nombre_variable: 'boton' },
                    { nombre: 'Cantidad', nombre_variable: 'cantidad' },
                ],
                datos: []
            },
            detalles: [],
            conversacion: null
        };
    },
    mounted() {

    },
    methods: {
        getreporte() {
            // console.log(this.form);
            this.buttonDisable = true;
            axios.post('interacciones-sin-watson/get_reporte', this.form).then(response => {
                // console.log(response.data);
                let {
                    // interacciones,
                    interacciones_transferidas,
                } = response.data;

                this.mostrarGraficos = true;
                this.buttonDisable = false;
                this.datos = interacciones_transferidas;
                this.graficar();

            }).catch(error => {
                this.buttonDisable = false;
                console.log(error);
            })
        },
        graficar() {
            const _this = this
            this.total_whatsapp = 0;
            this.total_facebook = 0;
            this.total_chatbot = 0;
            let interacciones_transferidas = this.datos;
            this.Mostrarlista = false;
            $(function () {
                $("#pie > svg").remove();
                $("#morris-bar-chart > svg").remove();
                $("#morris-bar-chart > .morris-default-style").remove();

                let total = 0;
                let total_derivadas = 0;
                let resuelta = 0;
                let no_resuelta = 0;
                _this.dt2.datos = [];
                let botones = [];
                let keys = [];
                let datos = [];
                let what = 0;
                let face = 0;
                let chatb = 0;
                for (let i = 0; i < interacciones_transferidas.length; i++) {
                    total_derivadas += interacciones_transferidas[i].total_derivadas;
                    no_resuelta += interacciones_transferidas[i].total_insatisfactorias;
                    resuelta += interacciones_transferidas[i].total_satisfactorias;

                    // console.log(parseInt(interacciones_transferidas[i].canal_wsp));

                    what = what + parseInt(interacciones_transferidas[i].canal_wsp);
                    face = face + parseInt(interacciones_transferidas[i].canal_facebook);
                    chatb = chatb + parseInt(interacciones_transferidas[i].canal_chatbot);

                    let data = {
                        botones: JSON.parse(interacciones_transferidas[i].botones),
                    }
                    botones.push(data);
                }

                total = what + face + chatb;

                console.log(total);

                _this.total_whatsapp = what;
                _this.total_facebook = face;
                _this.total_chatbot = chatb;

                // console.log(botones);

                botones.forEach(element => {
                    Object.entries(element.botones).forEach(([key, value]) => {
                        let data = {};
                        data['boton'] = key;
                        data['cantidad'] = value;
                        let x = datos.find(ele => {
                            return ele.boton == key
                        })

                        if (!x) {
                            datos.push(data);
                        }else{
                            let index = datos.indexOf(x);
                            datos[index].cantidad = datos[index].cantidad + data.cantidad;
                        }

                    });
                });

                _this.dt2.datos = datos;

                // console.log(keys);
                // console.log(datos);

                // if (3 > 0) {
                //     Morris.Bar({
                //         element: "morris-bar-chart",
                //         data: datos,
                //         xkey: "y",
                //         ykeys: keys,
                //         labels: keys,
                //         hideHover: "auto",
                //         resize: true,
                //         barColors: ["#1ab394", "#cacaca", "#71b234", "#716567", "#715156"],
                //     });
                // }

                // let interacciones = interacciones_transferidas.filter(element => {
                //     return element.tipo_motivo_fin == "En curso" ||
                //         element.tipo_motivo_fin == "Resuelta" ||
                //         element.tipo_motivo_fin == "No Resuelta"
                // })

                let en_curso = total_derivadas - resuelta - no_resuelta;
                let label_1 = "En curso " + (en_curso ?? 0);
                let label_2 = "Resuelta " + resuelta;
                let label_3 = "No resuelta " + no_resuelta;
                let label_4 = "Derivadas " + total_derivadas;

                c3.generate({
                    bindto: "#pie",
                    data: {
                        columns: [
                            [label_1, (total_derivadas - resuelta - no_resuelta) / total_derivadas],
                            [label_2, resuelta / total_derivadas],
                            [label_3, no_resuelta / total_derivadas],
                        ],
                        colors: {
                            label_1: '#1ab394',
                            label_2: '#3e872d',
                            label_3: '#3e6511',
                        },
                        type: "pie",
                    },
                });

                c3.generate({
                    bindto: "#pie2",
                    data: {
                        columns: [
                            ["No Derivadas " + (total - total_derivadas), (total - total_derivadas) / total],
                            [label_4, total_derivadas / total],
                        ],
                        colors: {
                            label_1: '#395fa3',
                            label_2: '#1fba91',
                        },
                        type: "pie",
                    },
                });
            });
        },
        mostrarReporte(tipo) {
            this.tipo_reporte = tipo;
            this.getList(tipo);

        },
        getList(tipo) {
            this.form['tipo'] = tipo;
            this.Mostrarlista = true;

            axios.post('interacciones-sin-watson/get_list', this.form).then(response => {
                this.dt.datos = response.data.map(element => {
                    return {
                        direccion_mensaje: element.direccion_mensaje,
                        emisor: element.emisor,
                        receptor: element.receptor,
                        canal: element.canal.nombre,
                        id_inter_global: element.id_inter_global,
                        created_at: element.created_at,
                        detalles: element.detalles,
                    }
                })
            });
        },
        abrirModal(item) {
            console.log(item);
            this.conversacion = item.data;
            this.detalles = item.data.detalles
            // console.log(this.detalles);
            $('#Modal').modal('show')

        },
        hide() {
            // console.log("entre");
            this.dt.datos = [];
            $('#Modal').modal('hide')
        },
        revisa_direccion(mensaje) {
            if (this.conversacion.direccion_mensaje == "Entrada" && this.conversacion.emisor != mensaje.emisor) {
                return "right"
            }

            if (this.conversacion.direccion_mensaje == "Salida" && this.conversacion.emisor != mensaje.emisor) {
                return "right"
            }

            return "";
        },
        muestra_mensaje(mensaje) {
            if (this.conversacion.direccion_mensaje == "Entrada") {
                if (this.conversacion.emisor != mensaje.emisor)
                    return this.conversacion.receptor + ": " + mensaje.mensaje
                else
                    return this.conversacion.emisor + ": " + mensaje.mensaje
            } else {
                if (this.conversacion.emisor != mensaje.emisor)
                    return this.conversacion.emisor + ": " + mensaje.mensaje
                else
                    return this.conversacion.receptor + ": " + mensaje.mensaje
            }
        },
    },
}
</script>

<style>
.conver {
    border: 1px solid;
    border-radius: 8px;
    padding: 5px;
    margin-bottom: 5px;
}

.right {
    text-align: right;
    margin-bottom: 6px;
    /* background: rgb(147 235 169); */
    background: rgb(62 105 113);
    color: white;
}
</style>
